import { socialApiClient } from '@/shared/api-client/social-api-client';

export const translateTranscript = async (post_id: string, lang: string) => {
  const response = await socialApiClient.get(`posts/${post_id}/translate/video`, {
    searchParams: {
      lang,
    },
  });
  return response.json<{
    transcript: string;
    caption: string;
  }>();
};

export const translateOriginalContents = async (post_id: string, lang: string) => {
  const response = await socialApiClient.get(`posts/${post_id}/translate/content`, {
    searchParams: {
      lang,
    },
  });
  return response.json<{ content: string; title?: string }>();
};
